import { jsx as _jsx } from "react/jsx-runtime";
import { getConfig, getOauthClientId, isConfigSet } from '@local/app-config';
import { useMessagesContext } from '@local/messages-wds2/dist/MessagesContext';
import { trackError } from '@local/metrics/dist/src/metrics';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/GridLegacy';
import { useContext, useEffect } from 'react';
import { clearCombinedToken as clearAccessToken } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { clearCSRFState } from '../../store/sessionStorageHelpers/authStateHelpers';
import { clearDeeplink } from '../../store/sessionStorageHelpers/deeplinkHelper/deeplinkHelper';
import { clearEntitlements } from '../../store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { LOGOUT_REDIRECT_ERROR } from '../../strings';
import { LoginContext } from '../loginHandler/LoginContext';
function handleRedirect(url) {
    window.location.href = url;
}
function buildLogoutUrl(forceOauthPrefix) {
    let baseUrl = '';
    if (isConfigSet()) {
        const config = getConfig();
        baseUrl = config.bentleyBaseUrl;
    }
    if (baseUrl.length > 0) {
        const logoutCallback = `${window.location.origin}/login`;
        const oauthConsumerKey = getOauthClientId(forceOauthPrefix);
        const logoutUrl = new URL(`${baseUrl}/connect/endsession`);
        const query = logoutUrl.searchParams || new URLSearchParams();
        query.append('oauthConsumerKey', oauthConsumerKey);
        query.append('post_logout_redirect_uri', logoutCallback);
        logoutUrl.search = query.toString();
        return logoutUrl;
    }
    return undefined;
}
export function BentleyLogout() {
    const { forceOauthPrefix } = useContext(LoginContext);
    const { addMessage } = useMessagesContext();
    useEffect(() => {
        clearAccessToken();
        clearEntitlements();
        clearDeeplink();
        clearCSRFState();
        const logoutUrl = buildLogoutUrl(forceOauthPrefix);
        sessionStorage.clear();
        if (!logoutUrl) {
            trackError('Error getting config to buildLogoutUrl');
            window.location.reload();
            return;
        }
        try {
            handleRedirect(logoutUrl.href);
        }
        catch (error) {
            trackError('Error redirecting back to Login', JSON.stringify(error));
            addMessage({
                message: LOGOUT_REDIRECT_ERROR,
                severity: 'error',
            });
        }
    }, []);
    return (_jsx(Grid, { container: true, direction: "column", alignItems: "center", justifyContent: "center", style: { minHeight: '100vh' }, children: _jsx(Grid, { item: true, xs: 12, children: _jsx(CircularProgress, {}) }) }));
}
//# sourceMappingURL=BentleyLogout.js.map